import { motion } from "framer-motion";
import { BadgeCheck, PhoneCall, Percent, PiggyBank } from "lucide-react";

const POINTS = [
  {
    icon: BadgeCheck,
    title: "Un prix calculé sous vos yeux",
    text: "De 5 € à 15 € selon les kilomètres réels entre le point A et le point B, calculés automatiquement dans le formulaire — jamais plus.",
  },
  {
    icon: PhoneCall,
    title: "Puis confirmé avec vous",
    text: "Après votre réservation, je vous appelle pour confirmer le créneau et le tarif exact selon la distance et le poids.",
  },
  {
    icon: Percent,
    title: "Payez comme vous voulez",
    text: "Carte bancaire en ligne, espèces à la livraison ou virement. Tarif doux pour les habitués et les commandes groupées.",
  },
];

export default function Pricing() {
  return (
    <section id="tarifs" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-12 max-w-2xl"
        >
          <span className="mb-4 inline-flex w-fit rounded-full bg-terra/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-terra-dark">
            Tarifs transparents
          </span>
          <h2 className="font-serif text-2xl font-semibold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Un prix clair, <em className="italic text-forest">annoncé et confirmé</em>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-ink/5 sm:p-8"
            >
              <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-forest/10 text-forest">
                <p.icon className="h-6 w-6" />
              </span>
              <h3 className="mb-2 text-lg font-semibold text-ink sm:text-xl">{p.title}</h3>
              <p className="text-base leading-relaxed text-ink/65">{p.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 flex items-start gap-4 rounded-3xl bg-forest p-6 text-cream sm:p-8"
          data-testid="sap-banner"
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cream/10 text-terra">
            <PiggyBank className="h-6 w-6" />
          </span>
          <div>
            <h3 className="font-serif text-lg font-semibold sm:text-xl">50 % de crédit d'impôt en vue</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-cream/75 sm:text-base">
              Ma demande d'agrément <strong className="text-cream">Services à la Personne</strong> est en cours
              auprès de l'URSSAF. Une fois accordé, la moitié du prix de vos livraisons à domicile sera déduite de
              vos impôts sous forme de crédit d'impôt. Je vous tiendrai informés dès la réponse !
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
